export default {
  data: () => ({
    menuActionIndex: null,
  }),

  methods: {
    menuActionToggle(index = null) {
      if (this.menuActionIndex === index) {
        this.menuActionIndex = null;
      } else {
        this.menuActionIndex = index;
      }
    },

    $_menuAction_toggle(index = null) {
      if (this.menuActionIndex === index) {
        this.menuActionIndex = null;
      } else {
        this.menuActionIndex = index;
      }
    }
  }
}